import { HttpClient } from '@angular/common/http';
import { DownloadManagerService } from './download-manager.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./download-manager.service";
var BackupService = /** @class */ (function () {
    function BackupService(http, downloadManager) {
        this.http = http;
        this.downloadManager = downloadManager;
        this.baseUrl = '/backup';
        // Legacy compatibility
        this.lastDownloadedBytesMap = new Map();
    }
    /**
     * Get backups list
     */
    BackupService.prototype.getBackups = function (businessUnitId, page, pageSize) {
        var params = {
            page: page.toString(),
            per_page: pageSize.toString()
        };
        return this.http.get(this.baseUrl + '/' + businessUnitId, { params: params });
    };
    /**
     * Create backup
     */
    BackupService.prototype.createBackup = function (data) {
        return this.http.post(this.baseUrl, data);
    };
    /**
     * Update backup
     */
    BackupService.prototype.updateBackup = function (backupId, data) {
        return this.http.patch(this.baseUrl + '/' + backupId, data);
    };
    /**
     * Get backup details
     */
    BackupService.prototype.getBackupDetails = function (backupId) {
        return this.http.get(this.baseUrl + '/' + backupId);
    };
    /**
     * Start optimized download
     */
    BackupService.prototype.startOptimizedDownload = function (backupId, url, filename, onProgress, onComplete, onError) {
        var callbacks = {};
        if (onProgress) {
            callbacks.onProgress = function (progress) {
                onProgress(progress.progress, progress.downloadedBytes, progress.totalBytes);
            };
        }
        if (onComplete) {
            callbacks.onComplete = function () {
                onComplete();
            };
        }
        if (onError) {
            callbacks.onError = function (id, error) {
                onError(error);
            };
        }
        this.downloadManager.startDownload(backupId, url, filename, callbacks);
    };
    /**
     * Resume download
     */
    BackupService.prototype.resumeDownload = function (backupId, url, filename, onProgress, onComplete, onError) {
        var callbacks = {};
        if (onProgress) {
            callbacks.onProgress = function (progress) {
                onProgress(progress.progress, progress.downloadedBytes, progress.totalBytes);
            };
        }
        if (onComplete) {
            callbacks.onComplete = function () {
                onComplete();
            };
        }
        if (onError) {
            callbacks.onError = function (id, error) {
                onError(error);
            };
        }
        this.downloadManager.resumeDownload(backupId, url, filename, callbacks);
    };
    /**
     * Cancel download
     */
    BackupService.prototype.cancelDownload = function (backupId) {
        this.downloadManager.cancelDownload(backupId);
    };
    /**
     * Pause download
     */
    BackupService.prototype.pauseDownload = function (backupId) {
        this.downloadManager.pauseDownload(backupId);
    };
    /**
     * Check if download is active
     */
    BackupService.prototype.isDownloadActive = function (backupId) {
        return this.downloadManager.isDownloadActive(backupId);
    };
    /**
     * Get download progress
     */
    BackupService.prototype.getDownloadProgress = function (backupId) {
        return this.downloadManager.getDownloadProgress(backupId);
    };
    /**
     * Check for active downloads
     */
    BackupService.prototype.hasActiveDownloads = function () {
        return this.downloadManager.hasActiveDownloads();
    };
    /**
     * Get all downloads
     */
    BackupService.prototype.getAllDownloads = function () {
        return this.downloadManager.getAllDownloads();
    };
    /**
     * LEGACY METHOD - maintained for backward compatibility
     */
    BackupService.prototype.downloadFileViaWorker = function (url, filename, backupId, onProgress) {
        var _this = this;
        console.warn('downloadFileViaWorker is deprecated. Use startOptimizedDownload instead.');
        return new Promise(function (resolve, reject) {
            var callbacks = {
                onProgress: function (progress) {
                    onProgress(progress.progress, progress.downloadedBytes, progress.totalBytes);
                },
                onComplete: function () {
                    resolve();
                },
                onError: function (id, error) {
                    reject({ message: error, downloadedBytes: 0 });
                }
            };
            _this.downloadManager.startDownload(backupId, url, filename, callbacks);
        });
    };
    /**
     * Legacy methods
     */
    BackupService.prototype.getLastDownloadedBytes = function (backupId) {
        var progress = this.downloadManager.getDownloadProgress(backupId);
        return (progress && progress.downloadedBytes) || this.lastDownloadedBytesMap.get(backupId) || 0;
    };
    BackupService.prototype.setLastDownloadedBytes = function (backupId, bytes) {
        this.lastDownloadedBytesMap.set(backupId, bytes);
    };
    BackupService.prototype.resetDownload = function (backupId) {
        this.lastDownloadedBytesMap.delete(backupId);
        if (typeof localStorage !== 'undefined') {
            localStorage.removeItem('download-meta-' + backupId);
        }
        this.downloadManager.cancelDownload(backupId);
    };
    /**
     * Validate backup for download
     */
    BackupService.prototype.validateBackupForDownload = function (backup) {
        if (!backup.download_link) {
            return { isValid: false, message: 'Download link not available' };
        }
        if (backup.status !== 'finished') {
            return { isValid: false, message: 'Backup is not ready for download' };
        }
        if (backup.deleted_at) {
            return { isValid: false, message: 'Backup has been deleted' };
        }
        return { isValid: true };
    };
    /**
     * Format file size
     */
    BackupService.prototype.formatFileSize = function (bytes) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };
    /**
     * Estimate download time
     */
    BackupService.prototype.estimateDownloadTime = function (downloadedBytes, totalBytes, startTime) {
        if (downloadedBytes === 0 || totalBytes === 0) {
            return 0;
        }
        var elapsedTime = (Date.now() - startTime) / 1000;
        var downloadSpeed = downloadedBytes / elapsedTime;
        var remainingBytes = totalBytes - downloadedBytes;
        return Math.ceil(remainingBytes / downloadSpeed);
    };
    /**
     * Get download stats
     */
    BackupService.prototype.getDownloadStats = function () {
        return this.downloadManager.getDownloadStats();
    };
    BackupService.ngInjectableDef = i0.defineInjectable({ factory: function BackupService_Factory() { return new BackupService(i0.inject(i1.HttpClient), i0.inject(i2.DownloadManagerService)); }, token: BackupService, providedIn: "root" });
    return BackupService;
}());
export { BackupService };
